<template>
  <div class="padding-conatiner" ref="padding">
    <div class="border-radius-header mb16">
      <span class="verticallyCenter"
        >{{ configData.paddingName || "内边距" }}
        <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
      </span>
      <div class="grid-type-btn floatRight" :class="request_prefix !== 'bigScreen' ? 'normal-pad-type' : ''">
        <el-tooltip class="item" effect="dark" content="全部内边距" placement="top-end" :open-delay="1000">
          <span class="pointer" :class="configData.paddingTypeFlag == 1 ? 'select' : ''" @click="changePaddingType(1)"
            ><i class="icon-portal-padding-around"></i
          ></span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="独立内边距" placement="top-end" :open-delay="1000">
          <span class="pointer" :class="configData.paddingTypeFlag == 2 ? 'select' : ''" @click="changePaddingType(2)"
            ><i class="icon-portal-padding"></i
          ></span>
        </el-tooltip>
      </div>
    </div>
    <div v-if="configData.paddingTypeFlag == 1">
      <slider-and-input
        :value.sync="paddingVal"
        :sliderMax="sliderMax"
        suffix="px"
        inputWidth="small"
        inputHeight="small"
      />
    </div>
    <div
      v-if="configData.paddingTypeFlag == 2"
      class="setting-item-grid"
      :class="request_prefix !== 'bigScreen' ? 'home' : 'home'"
    >
      <slider-and-input
        :value.sync="paddingTopVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        className="grid_home edge_2"
        inputWidth="small"
        inputHeight="small"
        tips="上边距"
      />
      <slider-and-input
        :value.sync="paddingRightVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        className="grid_home edge_3"
        inputWidth="small"
        inputHeight="small"
        tips="右边距"
      />
      <slider-and-input
        :value.sync="paddingBottomVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        className="grid_home edge_4"
        inputWidth="small"
        inputHeight="small"
        tips="下边距"
      />
      <slider-and-input
        :value.sync="paddingLeftVal"
        :sliderMax="sliderMax"
        suffix="px"
        class="mt16"
        className="grid_home edge_1"
        inputWidth="small"
        inputHeight="small"
        tips="左边距"
      />
    </div>
    <el-dialog
      title="说明"
      :append-to-body="true"
      :visible.sync="explainDialog"
      custom-class="explainDialog"
      v-if="paddingName === '内边距'"
    >
      <p class="fs14 tips">
        <span>内边距是指边界与内容之间的距离：</span>
        内边距的大小可以四个边一起设置，也可以每个边单独设置；内边距的值不允许为负数。
      </p>
      <div class="box"><video src="@/assets/images/tipsVideoImg/padding.mp4" controls></video></div>
    </el-dialog>
    <el-dialog
      title="说明"
      :append-to-body="true"
      :visible.sync="explainDialog"
      custom-class="explainDialog"
      v-if="paddingName === '外边距'"
    >
      <p class="fs14 tips">
        <span>外边距是指边界与内容之间的距离：</span>
        外边距的大小可以四个边一起设置，也可以每个边单独设置；外边距的值不允许为负数。
      </p>
      <div class="box"><video src="@/assets/images/tipsVideoImg/padding.mp4" controls></video></div>
    </el-dialog>
  </div>
</template>

<script>
import { historyCombineWrap } from "utils/revork"
import { getDiffVal, debounce } from "utils/index"
import complexSetMixin from "./complexSetMixin.js"
const setMixin = complexSetMixin()
export default {
  name: "cxPadding",
  mixins: [setMixin],
  props: {
    paddingName: {
      default: "内边距",
      required: false
    },
  },
  data() {
    return {
      this1: this,
      explainDialog: false,
    }
  },
  computed: {
    sliderMax: {
      get() {
        return this.configData.sliderMax || 500
      }
    },
    paddingTypeFlagVal: {
      get() {
        return this.configData.paddingTypeFlag
      },
      set(val) {
        this.configData.paddingTypeFlag = val
      }
    },
    paddingVal: {
      get() {
        return this.configData.padding
      },
      set(val) {
        this.configData.padding = val
      }
    },
    paddingTopVal: {
      get() {
        return this.configData.paddingTop
      },
      set(val) {
        this.configData.paddingTop = val
      }
    },
    paddingRightVal: {
      get() {
        return this.configData.paddingRight
      },
      set(val) {
        this.configData.paddingRight = val
      }
    },
    paddingBottomVal: {
      get() {
        return this.configData.paddingBottom
      },
      set(val) {
        this.configData.paddingBottom = val
      }
    },
    paddingLeftVal: {
      get() {
        return this.configData.paddingLeft
      },
      set(val) {
        this.configData.paddingLeft = val
      }
    }
  },
  methods: {
    changePaddingType: function (value) {
      if (this.paddingTypeFlagVal === value) {
        return
      }
      this.configData = {...this.configData,
          ...value === 2 ? {paddingTop: this.paddingVal, paddingRight: this.paddingVal, paddingLeft: this.paddingVal, paddingBottom: this.paddingVal} : {paddingVal: this.paddingTop},
          paddingTypeFlag: value}
    }
  }
}
</script>

<style scoped lang="scss">
.padding-conatiner {
  position: relative;
}
.padding-wrap {
  position: absolute;
  padding: 18px;
  width: 252px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  z-index: 10;
}
.w100_40 {
  width: calc(100% - 36px);
}
.color-picker-container:hover .bind-icon {
  display: inline-block;
}
.color-picker-container .bind-icon {
  display: none;
  position: absolute;
  right: 6px;
  top: 4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  text-align: center;
  font-size: 24px;
  cursor: pointer;
  overflow: hidden;
}
.color-picker-container .bind-icon:visited,
.color-picker-container .bind-icon:active {
  background-color: transparent;
}
.color-picker-container .color-text {
  width: calc(100% - 40px);
}
::v-deep .el-color-picker__mask {
  width: 20px;
  height: 20px;
  background-color: transparent;
}
::v-deep .el-color-picker.is-disabled .el-color-picker__color {
  border-radius: 50%;
  overflow: hidden;
}
.padding-list {
  /*padding: 8px;*/
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 8px;
  position: relative;
  > li:not(:last-child) {
    margin-bottom: 8px;
  }
  > li {
    background: var(--cardBgColor);
    position: relative;
    height: 32px;
    border-radius: 4px;
    padding: 6px;
    /* background: #ffffff; */
    /*border: 1px solid var(--borderColorFour);
    background-color: var(--dialogBgColor*/
    &:hover {
      /*background-color: var(--rulerBgColor);*/
      .right-handle-icon {
        display: inline-block;
      }
    }
    &.active {
      border-color: var(--themeColor);
      /*background-color: var(--dialogBgColor);*/
    }
  }
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
  }
  .delete-padding {
    font-size: 14px;
  }
}
.border-radius-header .tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.border-radius-header .tips-btn:hover {
  // background: rgba(31, 35, 41, 0.08);
  color: var(--themeColor);
}
::v-deep .explainDialog {
  width: 700px;
}
::v-deep .explainDialog .el-dialog__body {
  padding: 16px 24px 24px;
  color: var(--textColor);
}

::v-deep .explainDialog .tips span {
  font-weight: 600;
}

::v-deep .explainDialog .box {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  height: 366px;
  background: #fafafa;
  margin-top: 16px;
}

.grid-type-btn {
  position: absolute;
  right: 0;
  top: 0;
  height: 30px;
}
</style>
